import React from "react";
import { Share2, Facebook, Linkedin, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function SocialShare({ title, url, label = "Share:" }) {
  const shareUrl = encodeURIComponent(url || window.location.href);
  const shareTitle = encodeURIComponent(title);

  const platforms = [
    {
      name: "Facebook",
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
      color: "hover:text-blue-600"
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
      color: "hover:text-blue-700"
    },
    {
      name: "X (Twitter)",
      icon: MessageCircle,
      url: `https://x.com/intent/post?text=${shareTitle}&url=${shareUrl}`,
      color: "hover:text-black"
    },
    {
      name: "Reddit",
      icon: Share2,
      url: `https://reddit.com/submit?url=${shareUrl}&title=${shareTitle}`,
      color: "hover:text-orange-600"
    }
  ];

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-muted-foreground font-medium">{label}</span>
      <div className="flex gap-2">
        {platforms.map(platform => (
          <a
            key={platform.name}
            href={platform.url}
            target="_blank"
            rel="noopener noreferrer"
            title={`Share on ${platform.name}`}
            className={cn(
              "text-muted-foreground transition-colors p-1.5 hover:bg-muted rounded-lg",
              platform.color
            )}
          >
            <platform.icon className="w-4 h-4" />
          </a>
        ))}
      </div>
    </div>
  );
}